import { useState } from "react"
import { useSearchParams } from "react-router-dom"
import { weekdayCompareChartStore } from "./weekday-compare-chart-store"
import { langStore } from "@/stores/lang-store"
import WeekdayCompareChart from "./weekday-compare-chart"
import { weekdayDetailChartStore } from "./weekday-detail-chart-store"
import { aptSearchStore } from "@/routes/select/apt/apt-search-store"
import WeekdayDetailChartModal from "./weekday-detail-chart-modal"
import { ChevronRight } from "lucide-react"
import { formatMessage } from "@/utils/format-message"
import useIsMobile from "@/hooks/use-is-mobile"
import { RESOURCES } from "@/constants/resource-const"
import { weekdayBundle } from "./weekday-const"
import Wrapper from "@/components/wrapper"

const WeekdayCompareChartView = ({ className = "" }) => {
  const { lang } = langStore()
  const [searchParams] = useSearchParams()
  const resource = searchParams.get("resource") ?? "water"
  const dong = searchParams.get("dong")
  const ho = searchParams.get("ho")
  const isMobile = useIsMobile()

  const { ended_at } = aptSearchStore((s) => s.pickApt)
  const { unit, series } = weekdayCompareChartStore()

  const [open, setOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const handleOpenDetail = async () => {
    if (!dong || !ho) return

    try {
      setIsLoading(true)
      await weekdayDetailChartStore
        .getState()
        .apiGetWeekdayCompareChart({ dong, ho, resource, target_date: ended_at })
      setOpen(true)
    } catch (error) {
      console.error("상세 분석 로딩 실패:", error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Wrapper.shadow className={className}>
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-semibold text-gray-900">
          {formatMessage(weekdayBundle.title[lang], {
            resource: RESOURCES.find(({ id }) => id === resource).label[lang]
          })}
          <span className="ml-1 text-lg font-semibold text-gray-400">({unit})</span>
        </h2>
        {!isMobile && (
          <button
            className="group flex items-center gap-2
            px-3 py-1 rounded-xl
            bg-blue-50 hover:bg-blue-500
            text-blue-600 hover:text-white
            text-sm font-semibold
            transition-all duration-200
            shadow-sm hover:shadow-md
            active:scale-[0.98]
            cursor-pointer
          "
            onClick={handleOpenDetail}
            disabled={isLoading}
          >
            <span>{weekdayBundle.detailButton[lang]}</span>

            <ChevronRight className="w-4 h-4 transition-transform group-hover:scale-110" />
          </button>
        )}
      </div>

      <div className="md:h-auto md:flex-1 h-180">
        <WeekdayCompareChart series={series} />
      </div>

      <WeekdayDetailChartModal onClose={() => setOpen(false)} open={open} />
    </Wrapper.shadow>
  )
}

export default WeekdayCompareChartView
